import { render, staticRenderFns } from "./HistoricoFatura.vue?vue&type=template&id=66ab1b1c&"
import script from "./HistoricoFatura.vue?vue&type=script&lang=js&"
export * from "./HistoricoFatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports